import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { XOctagon } from 'lucide-react';

interface EndNodeData {
  label?: string;
  conditionType?: 'true' | 'false';
}

const EndNode: React.FC<NodeProps<EndNodeData>> = ({ data }) => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-1.5 px-6 py-3
        bg-gradient-to-b from-red-50 to-red-100 dark:from-red-950/60 dark:to-red-900/50
        border-2 border-dashed border-red-400 dark:border-red-600
        rounded-lg shadow-md
        select-none"
      style={{ minWidth: 120, minHeight: 56 }}
    >
      <XOctagon className="w-6 h-6 text-red-500 dark:text-red-400" />
      <span className="text-sm font-bold text-red-600 dark:text-red-300 tracking-wide uppercase">
        {data.label || 'Exit'}
      </span>

      {/* Target handles only - nothing flows out of an End node */}
      <Handle
        type="target"
        position={Position.Top}
        id="top"
        className="!w-2.5 !h-2.5 !bg-red-500 !border-2 !border-white dark:!border-gray-800 !min-w-0 !min-h-0"
      />
      <Handle
        type="target"
        position={Position.Left}
        id="left"
        className="!w-2.5 !h-2.5 !bg-red-500 !border-2 !border-white dark:!border-gray-800 !min-w-0 !min-h-0"
      />
      <Handle
        type="target"
        position={Position.Right}
        id="right"
        className="!w-2.5 !h-2.5 !bg-red-500 !border-2 !border-white dark:!border-gray-800 !min-w-0 !min-h-0"
      />
      <Handle
        type="target"
        position={Position.Bottom}
        id="bottom"
        className="!w-2.5 !h-2.5 !bg-red-500 !border-2 !border-white dark:!border-gray-800 !min-w-0 !min-h-0"
      />
    </div>
  );
};

export default EndNode;
